import { useSession } from 'next-auth/react';

import { User } from '@lessonPlanner/commons';
import { OrganizationSource } from '@lessonPlanner/enums';

export function useHasAllowedOrganizations(
  allowedOrganizations: OrganizationSource[] = [],
): boolean {
  const { data: session } = useSession();

  if (allowedOrganizations.length === 0) return true;

  const userOrganizations = (session?.user as User)?.organizations || [];

  return allowedOrganizations.some((organization) =>
    userOrganizations.some(
      (userOrg) => userOrg.name.toUpperCase() === organization,
    ),
  );
}
